
import BaseLayer from "./BaseLayer"
class GeoJsonLayer extends BaseLayer {

    constructor(options) {
        super(options.id);
        this._layerType = "geojson";
        this._dataSource = Cesium.GeoJsonDataSource.load(options.url, options);
        this._symbol = options.symbol;
        this.initSymbol();
        this.flyTo=options.flyTo;//自动定位
    }

    set show(val) {
        this._show = val
        this._dataSource.then((dataSource) => {
            dataSource.show = this._show
        })
    }
    allLoaded() {
        super.allLoaded();
        if(this._flyTo){
            viewer.zoomTo(this._dataSource);
        }
    }
    zoomTo(){
        viewer.zoomTo(this._dataSource);
    }
    eachFeature(method) {
        this._dataSource.then((dataSource) => {
            let entities = dataSource.entities.values
            entities.forEach((item) => {
                method(item);
            })
        })
        return this

    }

    initSymbol() {
        if (this._symbol) {
            var type = this._symbol.type;
            var styleField = this._symbol.styleField;
            var styleFieldOptions = this._symbol.styleFieldOptions;

            this.eachFeature((entity) => {
                var properties = entity.properties;
                if (properties && properties[styleField]) {
                    var color = styleFieldOptions[properties[styleField]].color;
                    var colorObj = Cesium.Color.fromCssColorString(color);
                    switch (type) {
                        //点
                        case "point":
                            break;
                        //线
                        case 'line':
                            break;
                        //面    
                        case 'polygon':
                            entity.polygon.material = colorObj;
                            break;
                        default:
                            break;
                    }
                }


            });
        }

    }

}

export default GeoJsonLayer;